import LandingHero from './LandingHero';
import DataPillars from './DataPillars';
import CoachSection from './CoachSection';
import HowItWorks from './HowItWorks';
import LandingBlogPosts from './LandingBlogPosts';
import LandingCtaSection from './LandingCtaSection';
import LandingConnectSection from './LandingConnectSection';

const LandingPage = () => (
  <div className="bodylytix-landing">
    <LandingHero />
    <DataPillars />
    <CoachSection />
    <HowItWorks />
    <LandingBlogPosts />
    <LandingCtaSection />
    <LandingConnectSection />
  </div>
);

export default LandingPage;
